"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    font-weight: ", ";\n    color: ", ";\n    cursor: pointer;\n    transition: color ", " ease;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    &:hover {\n        color: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SourceItem = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.sourceFontWeight;
}, function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.sourceColor;
}, function (props) {
  return props.theme.palette.transitionDuration;
}, function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.hoverSourceColor;
});

var _default = SourceItem;
exports["default"] = _default;